var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeEstimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1518-368H402V712h-1920z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1298-23H182v60h-1480z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.289c4.06 0 7.292-3.23 7.292-7.29 0-4.01-3.259-7.29-7.292-7.29C4.018.708.708 4.016.708 7.998c0 4.009 3.259 7.29 7.292 7.29zm0 .694C3.582 15.983.014 12.39.014 8 .014 3.634 3.634.014 8 .014c4.418 0 7.986 3.593 7.986 7.985A7.943 7.943 0 0 1 8 15.983zm3.386-5.41a.347.347 0 1 1-.406.562l-3.183-2.3a.347.347 0 0 1-.144-.28V3.202a.347.347 0 1 1 .694 0v5.174l3.04 2.195z",
    fill: "#636363",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEstimation);
export default __webpack_public_path__ + "static/media/time-estimation.153aa8163ca86faecbf9e7f918220688.svg";
export { ForwardRef as ReactComponent };